import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FAFAFA",
      d: "M4.238 13.062a.26.26 0 0 0 .198.433h7.127a.26.26 0 0 0 .24-.152q.031-.07.02-.147a.26.26 0 0 0-.062-.134L8.198 8.969a.26.26 0 0 0-.368-.026z",
      style: {"fill":"color(display-p3 .9804 .9804 .9804)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FAFAFA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.026 11.184h-.693A1.333 1.333 0 0 1 2 9.85V4.814A1.333 1.333 0 0 1 3.334 3.48h9.333a1.333 1.333 0 0 1 1.334 1.334l-.002 5.041a1.334 1.334 0 0 1-1.333 1.334h-.693m-7.947-.004h-.693A1.333 1.333 0 0 1 2 9.852",
      style: {"stroke":"color(display-p3 .9804 .9804 .9804)","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }